module.exports = __webpack_public_path__ + "img/share-back.d68f9b52.gif";